import React, { useEffect, useState } from "react";
import UsersTable from "./UsersTable";
import { fetchUserManagementInfo } from "../../requests";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { deleteAuthToken } from "../../utils/helper";
import { useDispatch } from "react-redux";
import useDebounce from "../hooks/useDebounce";
import _ from "lodash";
import { TABLE_HEADERS_USER_MANAGEMENT as TABLE_HEADERS, SEARCH_CONFIG_USER_MANAGEMENT as SEARCH_CONFIG } from "../../data/TableData";

function Index() {
  const [filter, setFilter] = useState({
    column: "",
    value: "",
  });
  const [searchValue, setSearchValue] = useState("");
  const [sort, setSort] = useState({
    column: "id",
    order: "DESC",
  });
  const [data, setData] = useState({
    headers: TABLE_HEADERS,
    rows: [],
    paginationData: {},
  });
  const [dateFilter, setDateFilter] = useState({
    startDate: "",
    endDate: "",
  });

  const debouncedSearchValue = useDebounce(searchValue, 300);
  const dispatch = useDispatch();

  useEffect(() => {
    handleUserMangementInfo();
  }, [filter, sort, dateFilter]);

  useEffect(() => {
    if (debouncedSearchValue !== undefined) {
      handleUserMangementInfo();
    }
  }, [debouncedSearchValue]);

  const handleUserMangementInfo = async (page = 1, limit = 25) => {
    dispatch(startLoader());
    try {
      const requestData = {
        page: page,
        limit: limit,
        filter_column: filter.column,
        filter_value: filter.value,
        sort_by: sort.column,
        sort_order: sort.order,
        start_date: dateFilter.startDate,
        end_date: dateFilter.endDate,
        search: debouncedSearchValue,
      };

      const response = await fetchUserManagementInfo(requestData);
      const rows = response.data.users;
      const paginationData = response.data.pagination;

      setData({
        headers: TABLE_HEADERS,
        rows: rows || [],
        paginationData: paginationData || {},
      });
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }

    dispatch(stopLoader());
  };
  
  const handleFilterChange = (filter) => {
    if (["active", "expired"].includes(_.lowerCase(filter.value))) {
      setFilter({ column: "sub_end", value: filter.value });
    } else if (
      ["premium", "basic", "free"].includes(_.lowerCase(filter.value))
    ) {
      setFilter({ column: "sub_type", value: filter.value });
    } else if (["english", "arabic"].includes(_.lowerCase(filter.value))) {
      setFilter({ column: "language", value: filter.value });
    } else {
      setFilter({ column: "", value: "" });
    }
  };

  const handleSearchChange = (value) => {
    setSearchValue(value);
  };

  const handleSorting = (sort) => {
    if (sort.value === "Name ASC") {
      setSort({ column: "full_name", order: "ASC" });
    } else if (sort.value === "Name DESC") {
      setSort({ column: "full_name", order: "DESC" });
    } else if (sort.value === "Sessions ASC") {
      setSort({ column: "sessions_count", order: "ASC" });
    } else if (sort.value === "Sessions DESC") {
      setSort({ column: "sessions_count", order: "DESC" });
    }
  };
  const handleDateFilterChange = (date) => {
    if (date.startDate && date.endDate) {
      setDateFilter({ startDate: date.startDate, endDate: date.endDate });
    }
  };

  const handlePageChange = (newPage, limit = 5) => {
    handleUserMangementInfo(newPage, limit);
  };

  return (
    <div className="container">
      <UsersTable
        headers={data.headers}
        rows={data.rows}
        handleFilterChange={handleFilterChange}
        handleSearchChange={handleSearchChange}
        searchValue={searchValue}
        handleSorting={handleSorting}
        handleDateFilterChange={handleDateFilterChange}
        dateFilter={dateFilter}
        onPageChange={handlePageChange}
        pagination={data.paginationData}
        searchConfig={SEARCH_CONFIG}
        variant="blue"
      />
    </div>
  );
}

export default Index;
